import { defineStore } from "pinia";
import type { ActionLog } from "@/rvapi";
import RvApi from "@/rvapi";

export const useLogStore = defineStore("log", {
  state: () => ({
    logData: [] as ActionLog[],
    searching: false,
    hasMore: true,
    debug: false,
    pageSize: 50,
  }),
  actions: {
    reset() {
      this.logData = [];
      this.debug = false;
      this.searching = false;
      this.hasMore = true;
    },
    toggleDebug() {
      this.debug = !this.debug;
      this.logData = [];
      this.searching = false;
      this.hasMore = true;
    },
    async write(
      message: string,
      deviceId: string,
      userId?: string,
      orderId?: string,
    ) {
      const log = await RvApi.writeActionLog(
        message,
        deviceId,
        userId,
        orderId,
      );
      this.logData.unshift(log);
    },
    async anotherPage(type: string, id: string) {
      this.searching = true;

      const log = await RvApi.searchActionLog(
        id,
        type,
        this.pageSize,
        this.logData.length,
        this.debug,
      );
      if (log.length < this.pageSize) {
        this.hasMore = false;
      }
      if (log.length > 0) {
        this.logData.push(...log);
      }

      this.searching = false;
    },
  },
});
